/* eslint-disable */
import React, { Component } from "react"
import moment from 'moment'
import { PropTypes } from "prop-types"
import { Row, Col, Table } from "react-bootstrap"
import { connect } from "react-redux"
import { bindActionCreators } from 'redux'
import { reduxForm, formValueSelector } from 'redux-form'
import ContentWrapper from "../../../../components/layout/ContentWrapper"
import { warning, blue } from '../../../../utils/constants'
import { 
  fetchOrphanedEvents,
  requestingEvents
} from "../../../../redux/actions/action_orphanedevent"
import {
  fetchPostEvent,
} from "../../../../redux/actions/action_postEvent";

const formName = 'orphanedevent'

class OrphanedEvents extends Component 
{
  constructor(props)
  {
    super(props)
    this.handleViewEventDetails = this.handleViewEventDetails.bind(this);
  }

  componentDidMount(){
    const { dispatch } = this.props
    dispatch(requestingEvents())
    dispatch(fetchOrphanedEvents())
  }

  handleViewEventDetails(id) {
    this.props.dispatch(fetchPostEvent(id));
    this.props.history.push('/postevent');
  }

  render()
   {  
    const { orphanedevents, recordsFound, searchCompleted } = this.props
    return (<ContentWrapper>
      <div className="content-heading">Orphaned Events</div>      
      {!recordsFound && searchCompleted === true && (
          <span style={{ color:warning }}>
            <i className='fa fa-info-circle' />&nbsp;&nbsp;No events found
          </span>
        ) 
      }
     { 
       recordsFound && searchCompleted === true && (<Row>
      <Col xs={6}>
        <Table striped>
          <thead>
            <tr>
              <th />
              <th>Event Name</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Event Director</th>
            </tr>
          </thead>
          <tbody>
            {
              (orphanedevents !== undefined) && orphanedevents.map((item, key) => (          
                <tr key={key}>
                  <td>{key + 1}</td>
                  <td>
                    <button className="btn btn-default" style={{ color: blue }} onClick={() => this.handleViewEventDetails(item.id)}>
                      <i aria-hidden="true" />&nbsp;{item.name}
                    </button>
                  </td>
                  <td>{moment(item.startDate).format('MM-DD-YYYY')}</td>
                  <td>{moment(item.endDate).format('MM-DD-YYYY')}</td>  
                  <td>{item.directorName}</td>           
                </tr>
              ))
            }
          </tbody>
        </Table>
      </Col>
    </Row>)
     }     
    </ContentWrapper>)
  }
}

OrphanedEvents.propTypes = {
  dispatch:PropTypes.func,
  orphanedevents:PropTypes.array,
  recordsFound:PropTypes.bool,
  searchCompleted: PropTypes.bool,
}

function mapStateToProps(state, ownProps) {  
  const formName        =  ownProps.form
  const selector        = formValueSelector(formName)
  const orphanedevents  = selector(state,'orphanedevents')
  const recordsFound = selector(state, 'recordsFound')
  const searchCompleted    = selector(state, 'searchCompleted')
  return {
    orphanedevents,
    recordsFound,
    searchCompleted,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchOrphanedEvents,
    requestingEvents,
    fetchPostEvent
    },dispatch)
}

export default reduxForm({
  form:formName,
})(connect(mapStateToProps, mapDispatchToProps)(OrphanedEvents))


// WEBPACK FOOTER //
// ./src/containers/postevent/components/orphaned/index.js